import { render, staticRenderFns } from "./DemandDetail.vue?vue&type=template&id=14cd3bf9&scoped=true"
import script from "./DemandDetail.vue?vue&type=script&lang=js"
export * from "./DemandDetail.vue?vue&type=script&lang=js"
import style0 from "./DemandDetail.vue?vue&type=style&index=0&id=14cd3bf9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cd3bf9",
  null
  
)

export default component.exports